import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bau365-product-section-country-availability',
  templateUrl: './section-country-availability.component.html',
  styleUrls: ['./section-country-availability.component.scss'],
})
export class SectionProductCountryAvailabilityComponent {
  @Input() countries?: string[];

  @Output() modalOpened: EventEmitter<void> = new EventEmitter<void>();

  openCountryAvailabilityModal = () => this.modalOpened.emit();
}
